import * as types from '../mutation-types'
import api from '@/api'
import {Message} from 'element-ui'
const state = {
  // 个人信息
  profile: {
  }
}

const getters = {
  profile: state => state.profile
}
const actions = {
  // 加载用户或者个人信息
  async loadProfile({commit}) {
    commit(types.TOGGLE_LOADING_STATUS)
    await api.get('user').then(response => {
      commit(types.TOGGLE_LOADING_STATUS)
      // 加载用户信息
      commit(types.LOAD_PROFILE, response.data)
    }).catch(error => {
      commit(types.TOGGLE_LOADING_STATUS)
      Message({message: '抱歉，服务器开了个小差！', type: 'error', customClass: 'c-msg', duration: 0, showClose: true})
      Promise.reject(error)
    })
  },
  // 更新个人信息
  updateProfile({state, commit}) {
    commit(types.TOGGLE_LOADING_STATUS)
    // 待更新项
    let profile = {}
    
    api.put('user/update', profile).then(response => {
      commit(types.TOGGLE_LOADING_STATUS)
      // 更新个人信息成功
      if (response.data.updated) {
        Message({message: '更新成功。', type: 'success', customClass: 'c-msg'})
      } else {
        Message({message: '更新失败。', type: 'error', customClass: 'c-msg'})
      }
    }).catch(error => {
      commit(types.TOGGLE_LOADING_STATUS)
      Message({message: '抱歉，服务器开了个小差！', type: 'error', customClass: 'c-msg', duration: 0, showClose: true})
      Promise.reject(error)
    })
  },
 
}
const mutations = {
  [types.LOAD_PROFILE](state, profile) {
    state.profile = profile
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js